import React, { useState } from 'react';
import { ArrowLeft, ArrowRight, List } from 'lucide-react';
import { OptionKey, Question } from '../data/types';

interface QuizDesktopNavProps {
  day: number;
  currentPos: number;
  totalCount: number;
  answeredCount: number;
  remainingCount: number;
  isFirst: boolean;
  isLast: boolean;
  isLocked: boolean;
  isSaving?: boolean;
  questions?: Question[];
  answers?: Record<number, OptionKey>;
  currentIndex?: number;
  onPrev: () => void;
  onNext: () => void;
  onOpenSubmitModal: () => void;
  onSelectQuestion?: (index: number) => void;
}

export const QuizDesktopNav: React.FC<QuizDesktopNavProps> = ({
  day,
  currentPos,
  totalCount,
  answeredCount,
  remainingCount,
  isFirst,
  isLast,
  isLocked,
  isSaving = false,
  questions = [],
  answers = {},
  currentIndex = 0,
  onPrev,
  onNext,
  onOpenSubmitModal,
  onSelectQuestion,
}) => {
  const [isScoreDetailOpen, setIsScoreDetailOpen] = useState(false);

  return (
    <div className="fc-desktop-nav">
      <div className="fc-nav-controls">
        <button
          type="button"
          className="fc-nav-btn prev"
          onClick={onPrev}
          disabled={isFirst || isSaving}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <ArrowLeft size={16} /> Câu trước
          </span>
        </button>

        <div className="fc-keyboard-hint">
          Phím A–E để chọn · ← → để chuyển câu · F để đánh dấu
        </div>

        {!isLast ? (
          <button
            type="button"
            className="fc-nav-btn next"
            onClick={onNext}
            disabled={isSaving}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              Câu sau <ArrowRight size={16} />
            </span>
          </button>
        ) : !isLocked ? (
          <button
            type="button"
            className="fc-nav-btn finish"
            onClick={onOpenSubmitModal}
            disabled={isSaving}
          >
            Hoàn thành Ngày {day}
          </button>
        ) : null}
      </div>

      <div className="fc-summary-strip">
        <div>
          Đã trả lời: <b className="mono-font">{answeredCount}</b>
        </div>
        <div>
          Còn lại: <b className="mono-font">{remainingCount}</b>
        </div>
      </div>

      {/* {isLocked && questions.length > 0 && (
        <div className="fc-score-breakdown-container">
          <button
            type="button"
            className={`fc-score-breakdown-btn ${isScoreDetailOpen ? 'active' : ''}`}
            onClick={() => setIsScoreDetailOpen((prev) => !prev)}
            aria-expanded={isScoreDetailOpen}
            title="Xem chi tiết điểm từng câu"
          >
            <List size={16} />
            <span>Xem chi tiết điểm từng câu</span>
          </button>

          {isScoreDetailOpen && (
            <div className="fc-score-breakdown-card">
              <div className="fc-score-breakdown-header">CHI TIẾT ĐIỂM</div>
              <div className="fc-score-breakdown-list">
                {questions.map((q, idx) => {
                  const selectedKey = answers[q.id];
                  const selectedOpt = q.options?.find((o) => o.key === selectedKey);
                  const earned =
                    q.earnedScore !== undefined
                      ? Number(q.earnedScore)
                      : selectedOpt?.score !== undefined
                      ? Number(selectedOpt.score)
                      : 0;
                  const max =
                    q.maxScore ||
                    Math.max(...(q.options?.map((o) => o.score ?? 0) || [5]), 5);
                  const isZero = earned === 0;
                  const isMax = earned === max && max > 0;
                  const isCurrent = idx === currentIndex;

                  return (
                    <div
                      key={q.id || idx}
                      className={`fc-score-breakdown-item ${isCurrent ? 'current' : ''}`}
                      onClick={() => onSelectQuestion?.(idx)}
                      title={`Chuyển đến câu ${idx + 1}`}
                    >
                      <div className="fc-score-breakdown-qlabel">
                        <span>Câu</span>
                        <span>{idx + 1}</span>
                      </div>
                      <div
                        className={`fc-score-breakdown-points ${
                          isZero ? 'zero' : isMax ? 'max' : 'normal'
                        }`}
                      >
                        {earned}/{max}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )} */}
    </div>
  );
};
